import { Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dcf-common-radio',
  standalone: true,
  imports: [CommonModule, FormsModule],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DcfCommonRadioComponent), multi: true }],
  template: `
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Radio</label>
      <div class="space-y-2">
        <label class="flex items-center">
          <input type="radio" name="radio" value="option1" [(ngModel)]="value" class="h-4 w-4 text-blue-600">
          <span class="ml-2 text-sm text-gray-700">Option 1</span>
        </label>
        <label class="flex items-center">
          <input type="radio" name="radio" value="option2" [(ngModel)]="value" class="h-4 w-4 text-blue-600">
          <span class="ml-2 text-sm text-gray-700">Option 2</span>
        </label>
      </div>
    </div>
  `
})
export class DcfCommonRadioComponent implements ControlValueAccessor {
  value: any = null;
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void { this.value = value; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { }
}
